import React, { useState } from 'react'
import { Col, Panel, Row, Table } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { Controller, useForm } from 'react-hook-form'
import notification from '../../utils/notification'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { cloneDeep, isEmpty } from 'lodash-es'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { GetAssessmentMAndESelfSearch } from '../../redux/actions/assessment'

export default function MAndESelfProjectListWidgets({ schema: _schema, ...props }) {
  const history = useHistory()

  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, reset, clearErrors } = useForm()

  const [formSchema, setFormSchema] = useState(_schema)
  const [isRefash, setIsRefash] = useState(false)
  const [datas, setData] = useState(formSchema.values || [])
  const [totalSize, setTotalSize] = useState(formSchema.totalSize || 0)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState()
  const [request, setRequest] = useState({
    pageNum: 1,
    pageSize: displayLength,
  })

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleSearch = async (req) => {
    setLoading(true)
    try {
      // console.log('req : ', req)

      const response = await GetAssessmentMAndESelfSearch(req)

      // console.log('response ', response)

      if (response?.length > 0) {
        setData(response || [])
        setTotalSize(response[0].totalSize || 0)
        // notification.open('success', {
        //   title: SAVE_SUCCESS_MSG,
        //   duration: 5000,
        // })
        onRefash()
      } else {
        setData([])
        setTotalSize(0)
        onRefash()
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
  }

  const onSubmit = (data) => {
    // console.log('onSubmit:', data)

    let req = {
      projectCode: data?.projectCode,
      projectName: data?.projectName,
      pageNum: 1,
      pageSize: displayLength,
    }

    setPage(1)
    setRequest(req)
    handleSearch(req)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)

    let req = cloneDeep(request)

    req['pageNum'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)

    let req = cloneDeep(request)
    req['pageNum'] = 1
    req['pageSize'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  return (
    <Panel
      bordered
      // key={data.id}
      style={{ marginBottom: 10, marginTop: 10 }}
      collapsible
      defaultExpanded
      header={formSchema.header}
    >
      <Panel bordered style={{ marginBottom: 10, marginTop: -10 }} header={'ค้นหา'}>
        <Row style={{ marginTop: -10 }}>
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputForm
              schema={formSchema.projectCode}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              value={request.projectCode}
              onChange={(value) => {
                var req = cloneDeep(request)
                req['projectCode'] = value
                setRequest(req)
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <InputForm
              schema={formSchema.projectName}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              value={request.projectName}
              onChange={(value) => {
                var req = cloneDeep(request)
                req['projectName'] = value
                setRequest(req)
              }}
            />
          </Col>
        </Row>
        <hr />
        <Row style={{ textAlign: 'right' }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <SaveButton
              children="คันหา"
              icon="search"
              onClick={handleSubmit(onSubmit)}
              disabled={loading}
            />

            <CancelButton
              children="ยกเลิก"
              onClick={() => {
                // setValue('projectCode', '')
                // setValue('projectName', '')
                onSubmit()
              }}
            />
          </Col>
        </Row>
      </Panel>

      {!isRefash && (
        <>
          <Table
            wordWrap
            rowKey="rowNum"
            // height={400}
            autoHeight
            data={datas || []}
            loading={loading}
          >
            <Column align="center" width={100} fixed>
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell dataKey="rowNum" />
            </Column>

            <Column width={150} align="center">
              <HeaderCell>รหัสโครงการ</HeaderCell>
              <Cell dataKey="projectCode" />
            </Column>
            <Column width={350}>
              <HeaderCell>ชื่อโครงการ</HeaderCell>
              <Cell dataKey="projectName" />
            </Column>
            <Column width={150}>
              <HeaderCell>สถานะ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return (
                    <>
                      <labe>{rowData.statusName}</labe>
                      {rowData.sendDate && (
                        <>
                          <br />
                          <label style={{ color: '#fb8a81' }}>({rowData.sendDate})</label>
                        </>
                      )}
                    </>
                  )
                }}
              </Cell>
            </Column>
            <Column width={200}>
              <HeaderCell>ผู้ประเมิน</HeaderCell>
              <Cell dataKey="assessor" />
            </Column>
            <Column width={250} flexGrow={1}>
              <HeaderCell>อีเมลผู้ประเมิน</HeaderCell>
              <Cell dataKey="assessorEmail" />
            </Column>
            <Column width={150} fixed="right" align="center">
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData, index) => {
                  return (
                    <>
                      {rowData.disabled ? (
                        <ViewButton
                          style={{
                            marginRight: 10,
                            marginBottom: 10,
                          }}
                          children="แสดง"
                          disabled={isEmpty(rowData.id)}
                          onClick={() => {
                            sessionStorage.setItem('m_e_s_id', rowData.id)
                            sessionStorage.setItem('project_code', rowData.projectCode)

                            history.push(pathname.assessment.assessmentMAndESelfForm)
                          }}
                        />
                      ) : (
                        <SaveButton
                          children="ประเมิน"
                          disabled={rowData.disabled}
                          onClick={() => {
                            if (rowData.id) {
                              sessionStorage.setItem('m_e_s_id', rowData.id)
                            }
                            sessionStorage.setItem('project_code', rowData.projectCode)

                            history.push(pathname.assessment.assessmentMAndESelfForm)
                          }}
                        />
                      )}
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table>
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total || 0} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        </>
      )}
    </Panel>
  )
}
